(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8V0Nn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $67e443888f2c602c$export$71511d61b312f219; });
function $67e443888f2c602c$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("jpEPd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e22005240bbe95bc$export$71511d61b312f219; });
function $e22005240bbe95bc$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("gUZbi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c511559f70643d52$export$71511d61b312f219; });
function $c511559f70643d52$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c511559f70643d52$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $c511559f70643d52$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c511559f70643d52$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("26bsd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $187506d5b1cfb700$export$71511d61b312f219; });

var $afUn2 = parcelRequire("afUn2");

var $giCaB = parcelRequire("giCaB");

var $220cd = parcelRequire("220cd");

var $aCRvb = parcelRequire("aCRvb");
function $187506d5b1cfb700$export$71511d61b312f219(arr) {
    return (0, $afUn2._)(arr) || (0, $giCaB._)(arr) || (0, $aCRvb._)(arr) || (0, $220cd._)();
}

});
parcelRegister("afUn2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7777081c2a4b1a86$export$71511d61b312f219; });

var $IChKS = parcelRequire("IChKS");
function $7777081c2a4b1a86$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $IChKS._)(arr);
}

});
parcelRegister("IChKS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0861ceda66c08a50$export$71511d61b312f219; });
function $0861ceda66c08a50$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("giCaB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bddbef8d2db60240$export$71511d61b312f219; });
function $bddbef8d2db60240$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("220cd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $17abeb9ade6216e7$export$71511d61b312f219; });
function $17abeb9ade6216e7$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("aCRvb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7bc6f45e6716f784$export$71511d61b312f219; });

var $IChKS = parcelRequire("IChKS");
function $7bc6f45e6716f784$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $IChKS._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $IChKS._)(o, minLen);
}

});


parcelRegister("1FBxg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1376bc92f02b5b83$export$2e2bcd8739ae039; });

var $26bsd = parcelRequire("26bsd");
var $1376bc92f02b5b83$var$debounce = function(callback, wait) {
    var timeoutId = null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(function() {
            callback.apply(void 0, (0, $26bsd._)(args));
        }, wait);
    };
};
var $1376bc92f02b5b83$export$2e2bcd8739ae039 = $1376bc92f02b5b83$var$debounce;

});

/**
 * Resort Map JavaScript
 *
 * This file defines Resort Map
 * behavior.
 */ // load the google map
/* eslint-disable no-new */ /**
 * Google Map
 *
 * Sets up Google map, plus ties it to
 * some things like sidebar buttons.
 */ /**
 * Import dependencies
 */ function $5747ce19c6955d22$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $5747ce19c6955d22$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $5747ce19c6955d22$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $5747ce19c6955d22$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $8V0Nn = parcelRequire("8V0Nn");
var $98e692f35f78a408$var$extendStatics = function extendStatics1(d, b) {
    $98e692f35f78a408$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $98e692f35f78a408$var$extendStatics(d, b);
};
function $98e692f35f78a408$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $98e692f35f78a408$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $98e692f35f78a408$export$18ce0697a983be9b = function __assign1() {
    $98e692f35f78a408$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $98e692f35f78a408$export$18ce0697a983be9b.apply(this, arguments);
};
function $98e692f35f78a408$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $98e692f35f78a408$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $8V0Nn._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $98e692f35f78a408$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $98e692f35f78a408$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $8V0Nn._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $98e692f35f78a408$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $98e692f35f78a408$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $8V0Nn._)(x)) === "symbol" ? x : "".concat(x);
}
function $98e692f35f78a408$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8V0Nn._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $98e692f35f78a408$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $8V0Nn._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $98e692f35f78a408$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $98e692f35f78a408$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $98e692f35f78a408$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $98e692f35f78a408$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $98e692f35f78a408$export$45d3717a4c69092e(o, m, p);
}
function $98e692f35f78a408$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $98e692f35f78a408$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $98e692f35f78a408$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($98e692f35f78a408$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $98e692f35f78a408$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $98e692f35f78a408$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $98e692f35f78a408$export$10c90e4f7922046c(v) {
    return this instanceof $98e692f35f78a408$export$10c90e4f7922046c ? (this.v = v, this) : new $98e692f35f78a408$export$10c90e4f7922046c(v);
}
function $98e692f35f78a408$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $98e692f35f78a408$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $98e692f35f78a408$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $98e692f35f78a408$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $98e692f35f78a408$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $98e692f35f78a408$export$19a8beecd37a4c45 === "function" ? $98e692f35f78a408$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $98e692f35f78a408$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $98e692f35f78a408$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $98e692f35f78a408$var$ownKeys = function ownKeys1(o) {
    $98e692f35f78a408$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $98e692f35f78a408$var$ownKeys(o);
};
function $98e692f35f78a408$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $98e692f35f78a408$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $98e692f35f78a408$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $98e692f35f78a408$var$__setModuleDefault(result, mod);
    return result;
}
function $98e692f35f78a408$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $98e692f35f78a408$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $98e692f35f78a408$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $98e692f35f78a408$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $8V0Nn._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $98e692f35f78a408$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $8V0Nn._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $98e692f35f78a408$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $98e692f35f78a408$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $98e692f35f78a408$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $98e692f35f78a408$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $98e692f35f78a408$export$2e2bcd8739ae039 = {
    __extends: $98e692f35f78a408$export$a8ba968b8961cb8a,
    __assign: $98e692f35f78a408$export$18ce0697a983be9b,
    __rest: $98e692f35f78a408$export$3c9a16f847548506,
    __decorate: $98e692f35f78a408$export$29e00dfd3077644b,
    __param: $98e692f35f78a408$export$d5ad3fd78186038f,
    __esDecorate: $98e692f35f78a408$export$3a84e1ae4e97e9b0,
    __runInitializers: $98e692f35f78a408$export$d831c04e792af3d,
    __propKey: $98e692f35f78a408$export$6a2a36740a146cb8,
    __setFunctionName: $98e692f35f78a408$export$d1a06452d3489bc7,
    __metadata: $98e692f35f78a408$export$f1db080c865becb9,
    __awaiter: $98e692f35f78a408$export$1050f835b63b671e,
    __generator: $98e692f35f78a408$export$67ebef60e6f28a6,
    __createBinding: $98e692f35f78a408$export$45d3717a4c69092e,
    __exportStar: $98e692f35f78a408$export$f33643c0debef087,
    __values: $98e692f35f78a408$export$19a8beecd37a4c45,
    __read: $98e692f35f78a408$export$8d051b38c9118094,
    __spread: $98e692f35f78a408$export$afc72e2116322959,
    __spreadArrays: $98e692f35f78a408$export$6388937ca91ccae8,
    __spreadArray: $98e692f35f78a408$export$1216008129fb82ed,
    __await: $98e692f35f78a408$export$10c90e4f7922046c,
    __asyncGenerator: $98e692f35f78a408$export$e427f37a30a4de9b,
    __asyncDelegator: $98e692f35f78a408$export$bbd80228419bb833,
    __asyncValues: $98e692f35f78a408$export$e3b29a3d6162315f,
    __makeTemplateObject: $98e692f35f78a408$export$4fb47efe1390b86f,
    __importStar: $98e692f35f78a408$export$c21735bcef00d192,
    __importDefault: $98e692f35f78a408$export$da59b14a69baef04,
    __classPrivateFieldGet: $98e692f35f78a408$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $98e692f35f78a408$export$d40a35129aaff81f,
    __classPrivateFieldIn: $98e692f35f78a408$export$81fdc39f203e4e04,
    __addDisposableResource: $98e692f35f78a408$export$88ac25d8e944e405,
    __disposeResources: $98e692f35f78a408$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $98e692f35f78a408$export$889dfb5d17574b0b
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $jpEPd = parcelRequire("jpEPd");

var $gUZbi = parcelRequire("gUZbi");

var $26bsd = parcelRequire("26bsd");

var $8V0Nn = parcelRequire("8V0Nn");

function $7e4212c9302d2178$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $7e4212c9302d2178$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
// do not edit .js files directly - edit src/index.jst
var $7e4212c9302d2178$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, $8V0Nn._)(a)) == 'object' && (typeof b === "undefined" ? "undefined" : (0, $8V0Nn._)(b)) == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
var $7e4212c9302d2178$var$isEqual = /*@__PURE__*/ $7e4212c9302d2178$var$getDefaultExportFromCjs($7e4212c9302d2178$var$fastDeepEqual);
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7e4212c9302d2178$export$19fc78b4b5aa5d0d = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $7e4212c9302d2178$export$406cfe323c8bb8e4;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($7e4212c9302d2178$export$406cfe323c8bb8e4 || ($7e4212c9302d2178$export$406cfe323c8bb8e4 = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ var $7e4212c9302d2178$export$3b0d6d7590275603 = /*#__PURE__*/ function() {
    "use strict";
    function Loader(param) {
        var apiKey = param.apiKey, authReferrerPolicy = param.authReferrerPolicy, channel = param.channel, client = param.client, _param_id = param.id, id = _param_id === void 0 ? $7e4212c9302d2178$export$19fc78b4b5aa5d0d : _param_id, language = param.language, _param_libraries = param.libraries, libraries = _param_libraries === void 0 ? [] : _param_libraries, mapIds = param.mapIds, nonce = param.nonce, region = param.region, _param_retries = param.retries, retries = _param_retries === void 0 ? 3 : _param_retries, _param_url = param.url, url = _param_url === void 0 ? "https://maps.googleapis.com/maps/api/js" : _param_url, version = param.version;
        (0, $jpEPd._)(this, Loader);
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $7e4212c9302d2178$export$19fc78b4b5aa5d0d; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if (Loader.instance) {
            if (!$7e4212c9302d2178$var$isEqual(this.options, Loader.instance.options)) throw new Error("Loader must not be called again with different options. ".concat(JSON.stringify(this.options), " !== ").concat(JSON.stringify(Loader.instance.options)));
            return Loader.instance;
        }
        Loader.instance = this;
    }
    (0, $gUZbi._)(Loader, [
        {
            key: "options",
            get: function get() {
                return {
                    version: this.version,
                    apiKey: this.apiKey,
                    channel: this.channel,
                    client: this.client,
                    id: this.id,
                    libraries: this.libraries,
                    language: this.language,
                    region: this.region,
                    mapIds: this.mapIds,
                    nonce: this.nonce,
                    url: this.url,
                    authReferrerPolicy: this.authReferrerPolicy
                };
            }
        },
        {
            key: "status",
            get: function get() {
                if (this.errors.length) return $7e4212c9302d2178$export$406cfe323c8bb8e4.FAILURE;
                if (this.done) return $7e4212c9302d2178$export$406cfe323c8bb8e4.SUCCESS;
                if (this.loading) return $7e4212c9302d2178$export$406cfe323c8bb8e4.LOADING;
                return $7e4212c9302d2178$export$406cfe323c8bb8e4.INITIALIZED;
            }
        },
        {
            key: "failed",
            get: function get() {
                return this.done && !this.loading && this.errors.length >= this.retries + 1;
            }
        },
        {
            /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ key: "createUrl",
            value: function createUrl() {
                var url = this.url;
                url += "?callback=__googleMapsCallback&loading=async";
                if (this.apiKey) url += "&key=".concat(this.apiKey);
                if (this.channel) url += "&channel=".concat(this.channel);
                if (this.client) url += "&client=".concat(this.client);
                if (this.libraries.length > 0) url += "&libraries=".concat(this.libraries.join(","));
                if (this.language) url += "&language=".concat(this.language);
                if (this.region) url += "&region=".concat(this.region);
                if (this.version) url += "&v=".concat(this.version);
                if (this.mapIds) url += "&map_ids=".concat(this.mapIds.join(","));
                if (this.authReferrerPolicy) url += "&auth_referrer_policy=".concat(this.authReferrerPolicy);
                return url;
            }
        },
        {
            key: "deleteScript",
            value: function deleteScript() {
                var script = document.getElementById(this.id);
                if (script) script.remove();
            }
        },
        {
            /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ key: "load",
            value: function load() {
                return this.loadPromise();
            }
        },
        {
            /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ key: "loadPromise",
            value: function loadPromise() {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    _this.loadCallback(function(err) {
                        if (!err) resolve(window.google);
                        else reject(err.error);
                    });
                });
            }
        },
        {
            key: "importLibrary",
            value: function importLibrary(name) {
                this.execute();
                return google.maps.importLibrary(name);
            }
        },
        {
            /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ key: "loadCallback",
            value: function loadCallback(fn) {
                this.callbacks.push(fn);
                this.execute();
            }
        },
        {
            /**
     * Set the script on document.
     */ key: "setScript",
            value: function setScript() {
                var _this = this;
                var _a, _b;
                if (document.getElementById(this.id)) {
                    // TODO wrap onerror callback for cases where the script was loaded elsewhere
                    this.callback();
                    return;
                }
                var params = {
                    key: this.apiKey,
                    channel: this.channel,
                    client: this.client,
                    libraries: this.libraries.length && this.libraries,
                    v: this.version,
                    mapIds: this.mapIds,
                    language: this.language,
                    region: this.region,
                    authReferrerPolicy: this.authReferrerPolicy
                };
                // keep the URL minimal:
                Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                function(key) {
                    return !params[key] && delete params[key];
                });
                if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
                // which also sets the base url, the id, and the nonce
                /* eslint-disable */ (function(g) {
                    var _d;
                    // @ts-ignore
                    var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
                    // @ts-ignore
                    b = b[c] || (b[c] = {});
                    // @ts-ignore
                    var d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = function() {
                        return(// @ts-ignore
                        h || (h = new Promise(function(f, n) {
                            return $7e4212c9302d2178$var$__awaiter(_this, void 0, void 0, function() {
                                var _a;
                                return (0, $98e692f35f78a408$export$67ebef60e6f28a6)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                a = m.createElement("script")
                                            ];
                                        case 1:
                                            _state.sent();
                                            a.id = this.id;
                                            e.set("libraries", (0, $26bsd._)(r) + "");
                                            // @ts-ignore
                                            for(k in g)e.set(k.replace(/[A-Z]/g, function(t) {
                                                return "_" + t[0].toLowerCase();
                                            }), g[k]);
                                            e.set("callback", c + ".maps." + q);
                                            a.src = this.url + "?" + e;
                                            d[q] = f;
                                            a.onerror = function() {
                                                return h = n(Error(p + " could not load."));
                                            };
                                            // @ts-ignore
                                            a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                                            m.head.append(a);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        })));
                    };
                    // @ts-ignore
                    d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = function(f) {
                        for(var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            n[_key - 1] = arguments[_key];
                        }
                        return r.add(f) && u().then(function() {
                            return (_d = d)[l].apply(_d, [
                                f
                            ].concat((0, $26bsd._)(n)));
                        });
                    };
                })(params);
                // While most libraries populate the global namespace when loaded via bootstrap params,
                // this is not the case for "marker" when used with the inline bootstrap loader
                // (and maybe others in the future). So ensure there is an importLibrary for each:
                var libraryPromises = this.libraries.map(function(library) {
                    return _this.importLibrary(library);
                });
                // ensure at least one library, to kick off loading...
                if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
                Promise.all(libraryPromises).then(function() {
                    return _this.callback();
                }, function(error) {
                    var event = new ErrorEvent("error", {
                        error: error
                    }); // for backwards compat
                    _this.loadErrorCallback(event);
                });
            }
        },
        {
            /**
     * Reset the loader state.
     */ key: "reset",
            value: function reset() {
                this.deleteScript();
                this.done = false;
                this.loading = false;
                this.errors = [];
                this.onerrorEvent = null;
            }
        },
        {
            key: "resetIfRetryingFailed",
            value: function resetIfRetryingFailed() {
                if (this.failed) this.reset();
            }
        },
        {
            key: "loadErrorCallback",
            value: function loadErrorCallback(e) {
                var _this = this;
                this.errors.push(e);
                if (this.errors.length <= this.retries) {
                    var delay = this.errors.length * Math.pow(2, this.errors.length);
                    console.error("Failed to load Google Maps script, retrying in ".concat(delay, " ms."));
                    setTimeout(function() {
                        _this.deleteScript();
                        _this.setScript();
                    }, delay);
                } else {
                    this.onerrorEvent = e;
                    this.callback();
                }
            }
        },
        {
            key: "callback",
            value: function callback() {
                var _this = this;
                this.done = true;
                this.loading = false;
                this.callbacks.forEach(function(cb) {
                    cb(_this.onerrorEvent);
                });
                this.callbacks = [];
            }
        },
        {
            key: "execute",
            value: function execute() {
                this.resetIfRetryingFailed();
                if (this.loading) // do nothing but wait
                return;
                if (this.done) this.callback();
                else {
                    // short circuit and warn if google.maps is already loaded
                    if (window.google && window.google.maps && window.google.maps.version) {
                        console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match.");
                        this.callback();
                        return;
                    }
                    this.loading = true;
                    this.setScript();
                }
            }
        }
    ]);
    return Loader;
}();



var $1FBxg = parcelRequire("1FBxg");
/**
 * Snazzy Maps styling
 *
 * @see https://snazzymaps.com/build-a-map/edit/485127
 */ var $6b47da03fc1cf46e$var$styles = [
    {
        featureType: 'all',
        elementType: 'geometry',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'all',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#032e5c'
            }
        ]
    },
    {
        featureType: 'administrative.country',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative.country',
        elementType: 'geometry',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative.country',
        elementType: 'geometry.fill',
        stylers: [
            {
                visibility: 'on'
            }
        ]
    },
    {
        featureType: 'administrative.country',
        elementType: 'geometry.stroke',
        stylers: [
            {
                visibility: 'on'
            }
        ]
    },
    {
        featureType: 'administrative.country',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off'
            },
            {
                color: '#032e5c'
            }
        ]
    },
    {
        featureType: 'administrative.country',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'on'
            },
            {
                weight: '0.01'
            }
        ]
    },
    {
        featureType: 'administrative.country',
        elementType: 'labels.text.fill',
        stylers: [
            {
                weight: '0.01'
            }
        ]
    },
    {
        featureType: 'administrative.province',
        elementType: 'all',
        stylers: [
            {
                visibility: 'simplified'
            }
        ]
    },
    {
        featureType: 'administrative.province',
        elementType: 'geometry',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative.province',
        elementType: 'geometry.fill',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative.province',
        elementType: 'geometry.stroke',
        stylers: [
            {
                visibility: 'on'
            }
        ]
    },
    {
        featureType: 'administrative.province',
        elementType: 'labels',
        stylers: [
            {
                color: '#617993'
            },
            {
                gamma: '1.00'
            },
            {
                weight: '0.01'
            }
        ]
    },
    {
        featureType: 'administrative.province',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'on'
            }
        ]
    },
    {
        featureType: 'administrative.locality',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'on'
            },
            {
                color: '#617993'
            },
            {
                weight: '0.01'
            },
            {
                saturation: '0'
            },
            {
                lightness: '0'
            }
        ]
    },
    {
        featureType: 'administrative.neighborhood',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative.neighborhood',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative.land_parcel',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
            {
                color: '#f2f2f2'
            },
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'landscape.natural',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'landscape.natural.landcover',
        elementType: 'geometry.fill',
        stylers: [
            {
                visibility: 'on'
            },
            {
                color: '#fbf7f0'
            }
        ]
    },
    {
        featureType: 'landscape.natural.landcover',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#98bde2'
            },
            {
                visibility: 'on'
            }
        ]
    },
    {
        featureType: 'landscape.natural.terrain',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'poi',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'poi.attraction',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'all',
        stylers: [
            {
                saturation: -100
            },
            {
                lightness: 45
            },
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [
            {
                visibility: 'simplified'
            }
        ]
    },
    {
        featureType: 'road.arterial',
        elementType: 'all',
        stylers: [
            {
                visibility: 'simplified'
            }
        ]
    },
    {
        featureType: 'road.arterial',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'transit',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'transit.station',
        elementType: 'all',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'transit.station.airport',
        elementType: 'geometry',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'transit.station.airport',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'on'
            },
            {
                color: '#303944'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'all',
        stylers: [
            {
                color: '#46bcec'
            },
            {
                visibility: 'simplified'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#98bde2'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#032e5c'
            }
        ]
    }
];
var $6b47da03fc1cf46e$export$2e2bcd8739ae039 = $6b47da03fc1cf46e$var$styles;


/**
 * Setup map pins
 */ var $35081faf3f0adf6e$export$c9264d19af5e6eb9 = function(param) {
    var google = param.google, map = param.map, mapData = param.mapData, infowindow = param.infowindow, bounds = param.bounds;
    var markers = [];
    mapData.pins.forEach(function(marker) {
        var // activate this pin on click of corresponding sidebar button
        _document_querySelector;
        // get the pin's details
        var title = marker.title, content = marker.content;
        // default to using title as info window's content
        var info = title;
        // but if we have content
        if (content) {
            // parse the info window content to prevent xss
            var doc = new DOMParser().parseFromString(content, 'text/html');
            // use the info window content
            info = doc.documentElement.textContent;
        }
        // create the pin
        var latLng = new google.maps.LatLng(marker.lat, marker.lng);
        var pin = new google.maps.Marker({
            map: map,
            position: latLng,
            title: title,
            optimized: false,
            zIndex: 1,
            icon: {
                url: "".concat(mapData.url, "/dist/assets/images/pins/pin-generic.svg"),
                scaledSize: new google.maps.Size(50, 50)
            }
        });
        var logo = new google.maps.Marker({
            map: map,
            position: latLng,
            title: title,
            optimized: false,
            zIndex: 1,
            icon: {
                url: marker === null || marker === void 0 ? void 0 : marker.img,
                anchor: new google.maps.Point(15, 47),
                scaledSize: new google.maps.Size(30, 30)
            }
        });
        // add this marker for looping over later
        markers.push({
            pin: pin,
            logo: logo
        });
        // activate the info window when clicking this pin
        var moveToMarker = function() {
            var withZoom = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            // move to this marker
            map.panTo(pin.position);
            // open the info window with this pin's content
            infowindow.setContent(info);
            infowindow.open({
                anchor: pin,
                map: map
            });
            // move all markers to back and this one to front
            markers.forEach(function(mark) {
                mark.pin.setZIndex(1);
                mark.logo.setZIndex(1);
            });
            pin.setZIndex(2);
            logo.setZIndex(2);
            // maybe zoom to this pin
            if (withZoom) map.setZoom(9);
        };
        pin.addListener('click', function() {
            return moveToMarker();
        });
        logo.addListener('click', function() {
            return moveToMarker();
        });
        // add to bounds (so know where to center on screen)
        bounds.extend(latLng);
        (_document_querySelector = document.querySelector('[data-button-id="'.concat(marker.id, '-button"'))) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.addEventListener('click', function() {
            return moveToMarker(true);
        });
    });
    // handle map zooming
    google.maps.event.addListener(map, 'zoom_changed', function() {
        var zoom = map.getZoom();
        var sizes = {
            pin: {
                scaledSize: [
                    50,
                    50
                ]
            },
            logo: {
                anchor: [
                    14,
                    47
                ],
                scaledSize: [
                    28,
                    28
                ]
            }
        };
        if (zoom >= 8) sizes = {
            pin: {
                scaledSize: [
                    75,
                    75
                ]
            },
            logo: {
                anchor: [
                    22,
                    68.5
                ],
                scaledSize: [
                    42,
                    42
                ]
            }
        };
        // resize pins if they're not the correct size already
        if (markers[0].pin.icon.scaledSize.width !== sizes.pin.scaledSize[0]) markers.forEach(function(marker) {
            marker.pin.setIcon({
                url: marker.pin.icon.url,
                scaledSize: new google.maps.Size(sizes.pin.scaledSize[0], sizes.pin.scaledSize[1])
            });
            marker.logo.setIcon({
                url: marker.logo.icon.url,
                scaledSize: new google.maps.Size(sizes.logo.scaledSize[0], sizes.logo.scaledSize[1]),
                anchor: new google.maps.Point(sizes.logo.anchor[0], sizes.logo.anchor[1])
            });
        });
    });
    // send the markers
    return markers;
};


/**
 * Handle region zoom
 */ 
var $26bsd = parcelRequire("26bsd");
var $1c6c20a9d3a220f3$export$701db9d6768da897 = function(param) {
    var google = param.google, map = param.map, markers = param.markers, wrap = param.wrap;
    var toggles = wrap.querySelectorAll('.resort-map__tab-button--toggle');
    if (toggles) toggles.forEach(function(buttonEl) {
        var timer = null;
        buttonEl.addEventListener('click', function() {
            clearTimeout(timer);
            timer = setTimeout(function() {
                var _buttonEl_parentElement_querySelectorAll;
                var titles = [];
                (_buttonEl_parentElement_querySelectorAll = buttonEl.parentElement.querySelectorAll('ul')) === null || _buttonEl_parentElement_querySelectorAll === void 0 ? void 0 : _buttonEl_parentElement_querySelectorAll.forEach(function(ul) {
                    if (ul.dataset.within) titles = (0, $26bsd._)(titles).concat((0, $26bsd._)(ul.dataset.within.split(',')));
                });
                if (titles.length) {
                    bounds = new google.maps.LatLngBounds();
                    markers.forEach(function(marker) {
                        if (titles.includes(marker.pin.title)) bounds.extend(marker.pin.position);
                    });
                    map.fitBounds(bounds, 50);
                    var listener = google.maps.event.addListener(map, 'idle', function() {
                        if (map.getZoom() > 8) map.setZoom(8);
                        google.maps.event.removeListener(listener);
                    });
                }
            }, 100);
        });
        toggles[0].click();
    });
};


/**
 * Point of Interest pins
 */ var $12be7ba5cb4dba24$export$3fd8b4ec582138dc = function(param) {
    var google = param.google, map = param.map, mapData = param.mapData, infowindow = param.infowindow;
    var markers = [];
    mapData.poi.forEach(function(marker) {
        // normalize input
        var title = marker.Title, latitude = marker.Latitude, longitude = marker.Longitude, icon = marker.Icon;
        // default to using title as info window's content
        var info = title || '';
        // but if we have content
        if (title) {
            // const content = `<a href="${url}">${title}</a>`;
            var content = "&lt;p&gt;".concat(title, "&lt;/p&gt;");
            // parse the info window content to prevent xss
            var doc = new DOMParser().parseFromString(content, 'text/html');
            // use the info window content
            info = doc.documentElement.textContent;
        }
        // create the pin
        var latLng = new google.maps.LatLng(latitude, longitude);
        var pin = new google.maps.Marker({
            map: map,
            position: latLng,
            title: title,
            optimized: false,
            zIndex: 0,
            icon: {
                url: "".concat(mapData.url, "/dist/assets/images/pins/pin-").concat(icon || 'generic', ".svg"),
                scaledSize: new google.maps.Size(25, 25)
            }
        });
        // add this marker for looping over later
        markers.push({
            pin: pin
        });
        // activate the info window when clicking this pin
        var moveToMarker = function() {
            // move to this marker
            map.panTo(pin.position);
            // open the info window with this pin's content
            infowindow.setContent(info);
            infowindow.open({
                anchor: pin,
                map: map
            });
        };
        pin.addListener('click', function() {
            return moveToMarker();
        });
    });
    // handle map zooming
    google.maps.event.addListener(map, 'zoom_changed', function() {
        var zoom = map.getZoom();
        if (zoom < 6) markers.forEach(function(marker) {
            marker.pin.setMap(null);
        });
        else markers.forEach(function(marker) {
            marker.pin.setMap(map);
        });
    });
};


var /**
 * Create map(s)
 */ $37ab9b4c3c7c9bf1$var$_document_querySelectorAll;
($37ab9b4c3c7c9bf1$var$_document_querySelectorAll = document.querySelectorAll('.resort-map')) === null || $37ab9b4c3c7c9bf1$var$_document_querySelectorAll === void 0 ? void 0 : $37ab9b4c3c7c9bf1$var$_document_querySelectorAll.forEach(function(wrap) {
    var _mapData_pins;
    // get this map's unique id and related data
    var id = wrap.id;
    var mapData = window["".concat(id, "AquaminData")]; // from wp's localized data
    var mapEl = wrap.querySelector('.resort-map__topo');
    // if we have a map and pins
    if (mapEl && (mapData === null || mapData === void 0 ? void 0 : (_mapData_pins = mapData.pins) === null || _mapData_pins === void 0 ? void 0 : _mapData_pins.length)) {
        // load our map using our key
        var loader = new (0, $7e4212c9302d2178$export$3b0d6d7590275603)({
            apiKey: 'AIzaSyDtt0GJiA2w7alIKx_tSDSIOU1a2V4WWY4',
            version: 'weekly'
        });
        // when ready to load the map
        loader.load().then(/*#__PURE__*/ (0, $5747ce19c6955d22$export$71511d61b312f219)(function() {
            function initMap() {
                return _initMap.apply(this, arguments);
            }
            function _initMap() {
                _initMap = // initialize the map
                (0, $5747ce19c6955d22$export$71511d61b312f219)(function() {
                    var Map, map, bounds, infowindow, markers;
                    return (0, $98e692f35f78a408$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    google.maps.importLibrary('maps')
                                ];
                            case 1:
                                Map = _state.sent().Map;
                                map = new Map(mapEl, {
                                    zoom: 5,
                                    styles: (0, $6b47da03fc1cf46e$export$2e2bcd8739ae039),
                                    mapTypeControl: false,
                                    streetViewControl: false
                                });
                                // prep for storing bounds
                                bounds = new google.maps.LatLngBounds();
                                // prep for storing an info window we can reposition
                                infowindow = new google.maps.InfoWindow({
                                    ariaLabel: 'Marker Details'
                                });
                                // add resort pins
                                markers = (0, $35081faf3f0adf6e$export$c9264d19af5e6eb9)({
                                    google: google,
                                    map: map,
                                    mapData: mapData,
                                    infowindow: infowindow,
                                    bounds: bounds
                                });
                                // show all pins in frame (and again on resize)
                                map.fitBounds(bounds);
                                window.addEventListener('resize', (0, $1FBxg.default)(function() {
                                    return map.fitBounds(bounds);
                                }));
                                // add poi pins
                                (0, $12be7ba5cb4dba24$export$3fd8b4ec582138dc)({
                                    google: google,
                                    map: map,
                                    mapData: mapData,
                                    infowindow: infowindow
                                });
                                // zoom to regions
                                (0, $1c6c20a9d3a220f3$export$701db9d6768da897)({
                                    google: google,
                                    map: map,
                                    markers: markers,
                                    wrap: wrap
                                });
                                return [
                                    2
                                ];
                        }
                    });
                });
                return _initMap.apply(this, arguments);
            }
            return (0, $98e692f35f78a408$export$67ebef60e6f28a6)(this, function(_state) {
                // send it!
                initMap();
                return [
                    2
                ];
            });
        }));
    }
});


/**
 * Map tabs
 */ // get globally-available features
var // create essentially isolated, nested tabs via carefully crafted selectors
$335aba1d28e815d4$var$_document_querySelectorAll;
var $335aba1d28e815d4$var$tabs = window.aquaminTabs;
var $335aba1d28e815d4$var$toggle = window.aquaminToggle;
($335aba1d28e815d4$var$_document_querySelectorAll = document.querySelectorAll('.resort-map-acc')) === null || $335aba1d28e815d4$var$_document_querySelectorAll === void 0 ? void 0 : $335aba1d28e815d4$var$_document_querySelectorAll.forEach(function(el) {
    var _el_querySelectorAll;
    var id = el.id;
    (_el_querySelectorAll = el.querySelectorAll('[data-id]')) === null || _el_querySelectorAll === void 0 ? void 0 : _el_querySelectorAll.forEach(function(acc, i) {
        $335aba1d28e815d4$var$tabs("".concat(id, "-").concat(i), {
            selectors: {
                wrap: "#".concat(id, " .").concat(acc.dataset.id),
                toggles: "#".concat(id, " .").concat(acc.dataset.id, "-toggle"),
                content: "#".concat(id, " .").concat(acc.dataset.id, "-content")
            }
        });
    });
});
// set up mobile menu toggle
$335aba1d28e815d4$var$toggle('resort-map-menu', {
    wrap: '.resort-map__sidebar',
    triggers: '.resort-map__sidebar-toggle',
    menu: '.resort-map__sidebar-menu'
});



})();
//# sourceMappingURL=resort-map-script.js.map
